module.exports = __webpack_public_path__ + "img/work-01.b48331ba.png";